// Match the three UI compositions with a dedicated interaction viewport.
export function stageLayout(width,height,screen='play',safeBottom=0){
  if(screen==='pile'){
    const mobile=width<=760,landscape=width>height&&height<=600,top=landscape?120:mobile?165:190,bottom=landscape?130:mobile?180+safeBottom:150;
    return {mode:mobile?'mobile':'desktop',left:0,top,width,height:Math.max(150,height-top-bottom)};
  }
  const landscape=width>height&&height<=600;
  if(landscape){
    const left=screen==='play'?180:Math.min(230,width*.29),right=screen==='play'?(width>=700?208:194):24;
    return {mode:'landscape',left,top:72,width:Math.max(150,width-left-right),height:Math.max(130,height-96)};
  }
  if(width<=760){
    if(screen==='play'){
      const top=height<740?130:135,bottom=(height<740?175:180)+Math.max(0,safeBottom-16);
      return {mode:'mobile',left:0,top,width,height:Math.max(150,height-top-bottom)};
    }
    const compactGacha=screen!=='play'&&height<=640;
    const top=compactGacha?190:height<740?205:240,bottom=compactGacha?133:screen==='play'?(height<740?185:205):(height<740?265:305);
    return {mode:'mobile',left:0,top,width,height:Math.max(150,height-top-bottom)};
  }
  if(screen==='play'){
    // The whole window right of the panel, edge to edge, so there is room to
    // push the toy about. The header passes touches through between its buttons.
    const left=width*.04+(width<=1100?304:336)+32;
    return {mode:'desktop',left,top:0,width:width-left,height:Math.max(200,height)};
  }
  const left=Math.max(width*.35,width*.06+(width<=1100?260:300)+28);
  return {mode:'desktop',left,top:110,width:width-left-32,height:Math.max(200,height-(screen==='gacha'?380:174))};
}

// Keep the resting toy hand-sized on a large monitor, with room around it
// to pull and move it. Mobile uses the available width rather than desktop pixel caps.
export function playCameraDistance(viewport){
  const {width,height,mode}=viewport;
  const maxHeight=mode==='desktop'?Math.min(370,height*.46):height*.78;
  const maxWidth=mode==='desktop'?Math.min(410,width*.38):width*.85;
  const projection=height/(2*Math.tan(19*Math.PI/180));
  return Math.max(2.25*projection/maxHeight,2.5*projection/maxWidth)+.45;
}
